import React from 'react'
import { Phone, Mail, MapPin, Clock, MessageCircle, Users, Zap } from 'lucide-react'

const ContactSection = () => {
  const openChat = () => {
    // Use global function if available (preferred method)
    if (window.openBenChat) {
      window.openBenChat('contact-section')
    } else {
      // Fallback to scrolling to chat widget
      console.warn('Global openBenChat function not available, falling back to scroll behavior')
      const chatWidget = document.getElementById('chat-widget') || document.querySelector('.chat-button')
      if (chatWidget) {
        chatWidget.scrollIntoView({ behavior: 'smooth' })
        // Try to click it if it's a button
        if (chatWidget.click) chatWidget.click()
      } else {
        console.error('Chat widget not found - please ensure ChatbotIntegration component is mounted')
      }
    }
  }

  return (
    <section id="contact" className="section contact">
      <div className="container">
        <h2 className="section-title reveal-hidden">Contactez-Nous</h2>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '50px', fontSize: '1.1rem' }}>
          Ben vous accompagne 24h/24 pour répondre à toutes vos questions sur la greffe capillaire
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 400px',
          gap: '60px',
          alignItems: 'start',
          marginBottom: '60px'
        }} className="contact-main-grid reveal-hidden reveal-stagger-1">

          {/* Ben Contact Hub - Primary */}
          <div>
            <div style={{
              background: 'linear-gradient(135deg, #2F2F84 0%, #6466B0 100%)',
              borderRadius: '24px',
              padding: '50px 40px',
              textAlign: 'center',
              color: 'white',
              position: 'relative',
              overflow: 'hidden',
              marginBottom: '40px'
            }}>
              <div style={{
                position: 'absolute',
                top: '-50%',
                right: '-50%',
                width: '200%',
                height: '200%',
                background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
                transform: 'rotate(45deg)'
              }}></div>

              <div style={{ position: 'relative', zIndex: 2 }}>
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  margin: '0 auto 25px auto',
                  border: '4px solid rgba(255, 255, 255, 0.3)',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
                }}>
                  <video
                    src="/ben-motion.mp4"
                    autoPlay={true}
                    loop={true}
                    muted={true}
                    playsInline={true}
                    webkit-playsinline="true"
                    poster="/team/ben.jpg"
                    preload="metadata"
                    onLoadedData={(e) => {
                      // Ensure video plays on Safari
                      const playPromise = e.target.play();
                      if (playPromise !== undefined) {
                        playPromise.catch(() => {
                          console.log('Autoplay prevented');
                        });
                      }
                    }}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </div>

                <h3 style={{
                  fontSize: '2rem',
                  fontWeight: '700',
                  marginBottom: '15px',
                  color: 'white'
                }}>
                  Parlez Directement avec Ben
                </h3>

                <p style={{
                  fontSize: '1.2rem',
                  marginBottom: '30px',
                  opacity: 0.9,
                  lineHeight: '1.6'
                }}>
                  Votre expert en greffe capillaire disponible 24h/24.
                  Obtenez des réponses immédiates sur SAPHORÏ®, CHOÏ et SAPHIR.
                </p>

                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '30px',
                  marginBottom: '35px',
                  flexWrap: 'wrap'
                }}>
                  <div style={{ textAlign: 'center' }}>
                    <Zap size={24} color="#8B6F47" />
                    <div style={{ fontSize: '0.9rem', marginTop: '5px', opacity: 0.9 }}>
                      Réponse<br />immédiate
                    </div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <Users size={24} color="#8B6F47" />
                    <div style={{ fontSize: '0.9rem', marginTop: '5px', opacity: 0.9 }}>
                      Expert<br />spécialisé
                    </div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <Clock size={24} color="#8B6F47" />
                    <div style={{ fontSize: '0.9rem', marginTop: '5px', opacity: 0.9 }}>
                      24h/24<br />7j/7
                    </div>
                  </div>
                </div>

                <button
                  onClick={openChat}
                  style={{
                    background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                    border: 'none',
                    borderRadius: '50px',
                    padding: '18px 40px',
                    color: 'white',
                    fontSize: '1.2rem',
                    fontWeight: '700',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    margin: '0 auto',
                    boxShadow: '0 6px 20px rgba(40, 167, 69, 0.4)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-3px)'
                    e.target.style.boxShadow = '0 8px 25px rgba(40, 167, 69, 0.5)'
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)'
                    e.target.style.boxShadow = '0 6px 20px rgba(40, 167, 69, 0.4)'
                  }}
                >
                  <MessageCircle size={24} />
                  Commencer la Discussion
                </button>

                <div style={{
                  marginTop: '20px',
                  padding: '12px 20px',
                  background: 'rgba(255, 255, 255, 0.15)',
                  borderRadius: '15px',
                  fontSize: '0.9rem',
                  fontWeight: '600'
                }}>
                  En ligne maintenant - Pret a vous conseiller
                </div>
              </div>
            </div>

            <div style={{
              textAlign: 'center',
              color: '#666',
              fontSize: '1rem',
              fontStyle: 'italic'
            }}>
              Ben connaît toutes nos techniques et peut vous aider à choisir la solution parfaite pour votre cas
            </div>
          </div>

          {/* Traditional Contact Info - Secondary */}
          <div>
            <h3 style={{
              color: '#2F2F84',
              fontSize: '1.5rem',
              fontWeight: '600',
              marginBottom: '30px',
              textAlign: 'center'
            }}>
              Autres Moyens de Contact
            </h3>

            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '30px',
              boxShadow: '0 4px 20px rgba(47, 47, 132, 0.08)',
              border: '2px solid #E8EAF6'
            }}>
              <div className="info-item" style={{ marginBottom: '25px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                  <Phone size={20} style={{ color: '#2F2F84' }} />
                  <h4 style={{ color: '#2F2F84', margin: 0 }}>Téléphone</h4>
                </div>
                <p style={{ fontSize: '1.1rem', fontWeight: '600', color: '#2F2F84', margin: '5px 0' }}>
                  01 48 66 20 35
                </p>
                <p style={{ fontSize: '0.9rem', color: '#888', margin: 0 }}>Lundi-samedi 10h-19h</p>
              </div>

              <div className="info-item" style={{ marginBottom: '25px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                  <Mail size={20} style={{ color: '#2F2F84' }} />
                  <h4 style={{ color: '#2F2F84', margin: 0 }}>Email</h4>
                </div>
                <p style={{ fontSize: '1rem', color: '#2F2F84', margin: '5px 0' }}>
                  secretariat@cliniquedugrandparis.com
                </p>
                <p style={{ fontSize: '0.9rem', color: '#888', margin: 0 }}>Réponse sous 24h</p>
              </div>

              <div className="info-item" style={{ marginBottom: '25px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                  <MapPin size={20} style={{ color: '#2F2F84' }} />
                  <h4 style={{ color: '#2F2F84', margin: 0 }}>Adresse</h4>
                </div>
                <p style={{ margin: '5px 0', color: '#2F2F84' }}>37A Avenue d'Iéna</p>
                <p style={{ margin: '5px 0', color: '#2F2F84' }}>75116 Paris</p>
                <p style={{ fontSize: '0.9rem', color: '#888', margin: 0 }}>Métro Iéna - Parking payant</p>
              </div>

              <div className="info-item">
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                  <Clock size={20} style={{ color: '#2F2F84' }} />
                  <h4 style={{ color: '#2F2F84', margin: 0 }}>Horaires</h4>
                </div>
                <p style={{ margin: '5px 0', color: '#2F2F84' }}>Lundi - Samedi: 10h - 19h</p>
                <p style={{ margin: '5px 0', color: '#2F2F84' }}>Dimanche: Fermé</p>
                <p style={{ fontSize: '0.9rem', color: '#888', margin: 0 }}>Consultations sur rendez-vous</p>
              </div>
            </div>
          </div>
        </div>

        <div style={{
          textAlign: 'center',
          padding: '30px',
          background: 'linear-gradient(135deg, #E8EAF6 0%, #F0F2FF 100%)',
          borderRadius: '16px',
          border: '2px solid #D1D5FF'
        }} className="reveal-hidden reveal-stagger-2">
          <h4 style={{ color: '#2F2F84', marginBottom: '15px' }}>
            Pourquoi choisir Ben comme premier contact ?
          </h4>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '20px',
            marginTop: '20px'
          }}>
            <div>
              <strong style={{ color: '#2F2F84' }}>Instantane</strong>
              <p style={{ fontSize: '0.9rem', color: '#666', margin: '5px 0 0 0' }}>
                Réponses immédiates, pas d'attente
              </p>
            </div>
            <div>
              <strong style={{ color: '#2F2F84' }}>Expert</strong>
              <p style={{ fontSize: '0.9rem', color: '#666', margin: '5px 0 0 0' }}>
                Spécialisé en greffes capillaires
              </p>
            </div>
            <div>
              <strong style={{ color: '#2F2F84' }}>Discret</strong>
              <p style={{ fontSize: '0.9rem', color: '#666', margin: '5px 0 0 0' }}>
                Confidentialité totale garantie
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactSection